import * as GLightbox from 'glightbox';

$( document ).on( 'click', '[data-toggle="lightbox"]', function( event ) {
  event.preventDefault();
  window.activeLightbox = GLightbox( {
    elements: [
      {
        href: $( this ).attr( 'href' ),
        type: $( this ).data( 'type' ),
      },
    ],
    zoomable: false,
    draggable: false,
    closeButton: true,
    autoplayVideos: false,
  } );
  window.activeLightbox.open();
} );
